module.exports = __webpack_public_path__ + "static/media/gn.7de80736.svg";